import '../css/CareersTeaser.scss';
import { Link } from 'react-router-dom';
import CareerImage from '../assets/carrer.jpeg';

const CareersTeaser = () => (
  <section className="careers-teaser-section">
    <div className="careers-teaser-image-wrap">
      <img src={CareerImage} alt="Join the HoneyRock team" />
      <div className="careers-teaser-overlay" />
    </div>
    <div className="careers-teaser-content">
      <span className="careers-kicker">Join Our Team</span>
      <h2>Shape the Next Generation</h2>
      <p>
        We are always looking for passionate, dedicated educators and staff who share our love for
        children and our commitment to excellence. If you believe in building character alongside
        academics, there's a place for you at The HoneyRock School.
      </p>
      <Link to="/careers" className="careers-teaser-btn">View Open Positions</Link>
    </div>
  </section>
);

export default CareersTeaser;
